// EmailJS Configuration
// Replace TEMPLATE_ID with your actual template ID from EmailJS dashboard

export const EMAILJS_CONFIG = {
  PUBLIC_KEY: "QAQprxCkbO3YDweWW",
  SERVICE_ID: "service_jmzjxab",
  TEMPLATE_ID: "template_spd6emb", // User's actual template ID
};

// Usage in Contact.js:
// import { EMAILJS_CONFIG } from './emailjs-config';
// 
// emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
// 
// const response = await emailjs.send(
//   EMAILJS_CONFIG.SERVICE_ID,
//   EMAILJS_CONFIG.TEMPLATE_ID,
//   templateParams
// ); 